module.exports = __webpack_public_path__ + "static/media/Hair_3_blond_2.0c889f64.svg";